import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { setErrors } from '../common/errorsSlice'
import { AppThunk } from '../store'
import { getInformation } from '../../apis/information'
import {
  ResponseHeaderInformation,
} from '../../types/information'

interface InformationState {
  information: ResponseHeaderInformation | null
  isLoading: boolean
}

const initialState: InformationState = {
  information: null,
  isLoading: true,
}

const informationSlice = createSlice({
  name: 'noticeList',
  initialState,
  reducers: {
    requestStart: (state) => {
      state.isLoading = true
      return state
    },
    getInformationSuccess: (state, action: PayloadAction<ResponseHeaderInformation>) => {
      state.information = action.payload
      state.isLoading = false
      return state
    },
    requestFailure: (state) => {
      state.isLoading = false
      return state
    },
  },
})

export const {
  requestStart,
  getInformationSuccess,
  requestFailure,
} = informationSlice.actions

export const informationReducer = informationSlice.reducer

export const fetchInformation = (): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getInformation()
    .then((result) => {
      dispatch(getInformationSuccess(result))
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}
